// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError} from '@reduxjs/toolkit/query/react'

const STORAGE_KEY = 'accessToken';

const rawBaseQuery = fetchBaseQuery({
    baseUrl: 'http://127.0.0.1:9000/',
});

const dynamicBaseQuery: BaseQueryFn<
    FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    const apiKey = window.sessionStorage.getItem(STORAGE_KEY);


    if (args.url.endsWith("/user/login.html")) {
        return rawBaseQuery(args, api, extraOptions);
    }

    // gracefully handle scenarios where data to generate the URL is missing
    if (!apiKey) {
        return {
            error: {
                status: 400,
                statusText: 'Bad Request',
                data: 'No project ID received',
            },
        }
    }

    const adjustedArgs = { ...args, params: { ...args.params, apikey: apiKey } };
    // provide the amended url and other params to the raw base query
    return rawBaseQuery(adjustedArgs, api, extraOptions)
}

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
    baseQuery: dynamicBaseQuery,
    endpoints: () => ({}),
});
